import { useGetRTSolutionCardData } from "@/src/hooks/srp/RTSolutionView/getRTSolutionCardData"
import { FlightCard } from "@/src/types/flight"
import { getAirlineIcons } from "@/src/utils/confirmation/airlineUtils"
import { Box, Typography } from "@mui/material"

export const SelectedOnwardLegFlightInfo = (
    { onwardFlightData }: { onwardFlightData: FlightCard }
) => {
    const flightData = useGetRTSolutionCardData(onwardFlightData)
    return (
        <Box pt={0.5} display={"flex"} alignItems={"center"} gap={0.5}>
            <Box display={'flex'} maxWidth={150} overflow={'auto'} gap={0.5}>
                {getAirlineIcons(flightData.airlineCodes, 14, 14)}
            </Box>
            <Typography fontSize={12} fontWeight={400} color={'#000'}>{flightData.departureTime} - {flightData.arrivalTime}</Typography>

        </Box>
    )
}
